import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=f93823e6&"
import script from "./my-pagination.vue?vue&type=script&lang=js&"
export * from "./my-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports